import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
`;

export const FormContainer = styled.div`
  width: 45%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  gap: 32px;
  padding: 80px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  transition: all 200ms ease-in-out;
  
  @media (min-width: 1920px) {
    padding-inline: 200px;
  }

  @media (max-width: 1430px) {
    padding: 64px; 
  }

  @media (max-width: 950px) {
    width: 100%;
    padding: 80px;
    box-shadow: none;
  }
`;

export const InfoContainer = styled.div`
  background: linear-gradient(135deg, #321289, #D830AF);
  width: 55%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  
  padding: 40px;

  @media (max-width: 950px) {
    display: none; 
  }
`;

export const ContainerTitle = styled.div`
  padding-bottom: 40px;
  margin-bottom: 8px;
`;

export const Title = styled.h2`
  color: #1a1a1a;
  margin-bottom: 8px;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
`;

export const Text = styled.span`
  color: #6b7280;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
`;

export const InputText = styled.span`
  color: #6b7280;
  font-weight: 700;
  font-size: 12px;
`;

export const ContainerInput = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 8px;
  
  label {
    font-size: 14px;
    font-weight: 600;
    color: #744cb4;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const CustomLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Subtitle = styled.span`
  color: #6b7280;
  margin-bottom: 3px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  
  .form-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;
  }
  
  .forgot-password {
    color: #744cb4;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: color 200ms ease-in-out;
    text-decoration: none;
    
    &:hover {
      color: #8c62d1;
      text-decoration: underline;
    }
  }
`;
